export default __webpack_public_path__ + "static/media/(70).08d9a543.jpg";